<template>
  <b-col>
    <b-card
      sub-title="Všetky moje vecičky v ponuke"
      header="Celá ponuka"
      text-variant="dark"
    >
      <b-card-group deck>
        <postcard
          :source-pictutes="['/static/images/velkanoc/velkanoc42.jpg','/static/images/velkanoc/velkanoc43.jpg']"
          title-img="Veľkonočný zajačik - 4 €"
          subtitle-img="Pohľadnica"
          details-img="...jednoduchá a milá veľkonočná pohľadnička s motívom zajačika na lúke, ten bol vytvorený technikou decoupage, ručne vyrezaný a nalepený v 3D efekte na biely pohľadnicový základ. Posielam s ručne robenou obálkou na mieru."
          size-img="15 x 10,5 cm"
          material-img="obyčajný papier, špagát, kartón"
          kind-img="decoupage, cardmaking, lepenie"
        />
        <postcard
          :source-pictutes="['/static/images/velkanoc/velkanoc44.jpg','/static/images/velkanoc/velkanoc45.jpg']"
          title-img="Veľkonočný zajko - 4,20 €"
          subtitle-img="Pohľadnica"
          details-img="...jednoduchá veľkonočná pohľadnička s prírodným nádychom, bola ozdobená zajkom, ktorého som vytvorila technikou decoupage, ručne vyrezala a nalepila v 3D efekte na biely pohľadnicový základ. Pohľadničku som dozdobila pečiatkou, bielohnedou šnúrkou a listom. S pohľadničkou posielam ručne robenú obálku na mieru."
          size-img="14 x 10,5 cm"
          material-img="obyčajný papier, špagát, kartón"
          kind-img="decoupage, cardmaking, lepenie"
        />
        <postcard
          :source-pictutes="['/static/images/velkanoc/velkanoc1.jpg','/static/images/velkanoc/velkanoc2.jpg','/static/images/velkanoc/velkanoc3.jpg']"
          title-img="Krásna jar - 6 €"
          subtitle-img="Pohľadnica"
          details-img="...milá jarná pohľadnica s motívom jabloňových kvietkov, tie boli vytvorené technikou decoupage, ručne vyrezané a nalepené v 3D efekte na biely pohľadnicový základ, pohľadnička obsahuje text v sivej farbe - Krásnu jar-. Posielam s pevnou ručne robenou obálkou."
          size-img="15 x 10,5 cm"
          material-img="obyčajný papier, kartón"
          kind-img="decoupage, cardmaking, lepenie"
        />
      </b-card-group>
      <br>
      <b-card-group deck>
        <postcard
          :source-pictutes="['/static/images/velkanoc/velkanoc4.jpg','/static/images/velkanoc/velkanoc5.jpg','/static/images/velkanoc/velkanoc6.jpg']"
          title-img="Veľkonočné vajíčka - 4 €"
          subtitle-img="Pohľadnica"
          details-img="...otváracia pohľadnica v minimalistickom štýle s motívom vajíčok s florálnym zdobením, ktoré som vytvorila technikou decoupage, ručne vyrezala a nalepila v 3D efekte na biely ručne robený pohľadnicový základ. Pohľadničku som dozdobila ľanovou šnúrkou a pečiatkou. Posielam s ručne robenou obálkou na mieru."
          size-img="14 x 10,5 cm"
          material-img="obyčajný papier, kartón, špagát"
          kind-img="decoupage, cardmaking, lepenie"
        />
        <postcard
          :source-pictutes="['/static/images/velkanoc/velkanoc8.jpg','/static/images/velkanoc/velkanoc7.jpg']"
          title-img="Zlatý dážď venček - 5 €"
          subtitle-img="Pohľadnica"
          details-img="...jemná jarná pohľadnička so zlatým dažďom, ten som vytvorila technikou decoupage, ručne vyrezala a nalepila v 3D efekte, prizdobila bielou ľanovou mašličkou. Posielam s ručne robenou obálkou na mieru."
          size-img="15 x 10,5 cm"
          material-img="obyčajný papier, špagát, kartón"
          kind-img="decoupage, lepenie, cardmaking"
        />
        <postcard
          :source-pictutes="['/static/images/velkanoc/velkanoc9.jpg','/static/images/velkanoc/velkanoc10.jpg','/static/images/velkanoc/velkanoc11.jpg','/static/images/velkanoc/velkanoc12.jpg']"
          title-img="Čerešňová vetvička - 5 €"
          subtitle-img="Pohľadnica"
          details-img="...otváracia pohľadnica s motívom čerešňových vetvičiek, tie boli vytvorené technikou decoupage, precízne ručne vyrezané a nalepené v 3D efekte. Pohľadnica je vrstvená, vnútro a zadná strana bez textov v bielej farbe, posielam s ručne robenou obálkou."
          size-img="cca 14 x 14 cm"
          material-img="obyčajný papier, kartón"
          kind-img="decoupage, lepenie, cardmaking"
        />
      </b-card-group>
      <br>
      <b-card-group deck>
        <postcard
          :source-pictutes="['/static/images/velkanoc/velkanoc13.jpg','/static/images/velkanoc/velkanoc14.jpg','/static/images/velkanoc/velkanoc15.jpg','/static/images/velkanoc/velkanoc16.jpg','/static/images/velkanoc/velkanoc17.jpg']"
          title-img="Bahniatka - 6 €"
          subtitle-img="Pohľadnica"
          details-img="...pohľadnička s jarným venčekom, vytvorený je z ručne vyrezaných bahniatok a papierového tulipánika a lístkov, použila som techniku decoupage a venček naaranžovala v 3D efekte. Ozdobená je ľanovou mašličkou.  Pohľadnička je vrstvená, bez textov, v bielej farbe. Posielam s ručne robenou obálkou na mieru."
          size-img="13,5 x 13,5 cm"
          material-img="obyčajný papier, kartón, špagát"
          kind-img="decoupage, lepenie, cardmaking"
        />
        <postcard
          :source-pictutes="['/static/images/velkanoc/velkanoc18.jpg','/static/images/velkanoc/velkanoc19.jpg','/static/images/velkanoc/velkanoc20.jpg']"
          title-img="Zajačik - 4 €"
          subtitle-img="Pohľadnica"
          details-img="...otváracia pohľadnica s motívom zajačika, ten bol vytvorený technikou decoupage, nalepený v 3D efekte. Pohľadnica je vrstvená, vrchný papier je bielej farby s farebnými guličkami, jemne štruktúrovaný, vnútro a zadná strana bez textov v perlovo bielej farbe, posielam s ručne robenou obálkou."
          size-img="cca 15 x 10,5 cm"
          material-img="obyčajný papier, archivačný papier, špagát, kartón"
          kind-img="decoupage, lepenie, cardmaking"
        />
        <postcard
          :source-pictutes="['/static/images/velkanoc/velkanoc21.jpg','/static/images/velkanoc/velkanoc22.jpg','/static/images/velkanoc/velkanoc23.jpg']"
          title-img="Veľkonočné kohútiky - 5 € / sada"
          subtitle-img="Dekorácia"
          details-img="...veľkonočná dekorácia (visačky), z oboch strán s motívom kohútika, na špagátiku s mašličkou, prelakované ...cena za 3ks (1sada)"
          size-img="...cca 6,5 x 4 cm"
          material-img="obyčajný papier, špagát"
          kind-img="decoupage, lepenie"
        />
      </b-card-group>
      <br>
      <b-card-group deck>
        <postcard
          :source-pictutes="['/static/images/velkanoc/velkanoc24.jpg','/static/images/velkanoc/velkanoc25.jpg','/static/images/velkanoc/velkanoc26.jpg','/static/images/velkanoc/velkanoc27.jpg','/static/images/velkanoc/velkanoc28.jpg','/static/images/velkanoc/velkanoc29.jpg']"
          title-img="Veľkonočné vajíčka - 4,40 € / sada"
          subtitle-img="Dekorácia"
          details-img="...veľkonočné vajíčka na zavesenie, sú vytvorené technikou decoupage, z oboch strán rovnaký motív. Dajú sa zavesiť pomocou bielej šnúrky, každá kraslica má inú dĺžku šnúrky. Sú prelakované lakom na decoupage, aby boli pevné a odolné. Môžete si ich zavesiť na halúzku alebo pripevniť na balíčky pre šibačov. V sade sa nachádza 5 veľkonočných vajíčok v hnedej a béžovej farbe."
          size-img="6 x 4 cm"
          material-img="kartón, špagát"
          kind-img="decoupage, lepenie"
        />
        <postcard
          :source-pictutes="['/static/images/velkanoc/velkanoc30.jpg','/static/images/velkanoc/velkanoc31.jpg','/static/images/velkanoc/velkanoc32.jpg']"
          title-img="Ovečka - 4 €"
          subtitle-img="Pohľadnica"
          details-img="...milá otváracia pohľadnica s motívom ovečky, tá bola vytvorená technikou decoupage, ručne vyrezaná, nalepená v 3D efekte na ručne robený základ pohľadnice v bielej farbe. Pohľadnička je vo vnútri bez textov, na voľno previazaná prírodnou ľanovou šnúrkou. Posielam s pevnou ručne robenou obálkou na mieru."
          size-img="...15 x 10,5 cm"
          material-img="obyčajný papier, kartón, špagát"
          kind-img="decoupage, lepenie, cardmaking"
        />
        <postcard
          :source-pictutes="['/static/images/velkanoc/velkanoc33.jpg','/static/images/velkanoc/velkanoc34.jpg','/static/images/velkanoc/velkanoc35.jpg','/static/images/velkanoc/velkanoc36.jpg']"
          title-img="Veľkonočný venček - 5 €"
          subtitle-img="Pohľadnica"
          details-img="...pohľadnica s motívom jarného venčeka, ten bol vytvorený technikou decoupage, ručne vyrezaný a nalepený v 3D efekte. Pohľadnica je vrstvená, vnútro a zadná strana sú bielej farby bez textov, na voľno previazaná motúzikom. Posielam s pevnou ručne robenou obálkou."
          size-img="cca 14,5 x 14,5 cm"
          material-img="obyčajný papier, špagát, kartón"
          kind-img="decoupage, lepenie, cardmaking"
        />
      </b-card-group>
      <br>
      <b-card-group deck>
        <postcard
          :source-pictutes="['/static/images/velkanoc/velkanoc37.jpg','/static/images/velkanoc/velkanoc38.jpg']"
          title-img="Zlatý dážď vetvička - 6 €"
          subtitle-img="Pohľadnica"
          details-img="...otváracia pohľadnica s motívom vetvičky zlatého dažďa, tá bola vytvorená technikou decoupage, precízne ručne vyrezaná kvietok po kvietku a nalepená v 3D efekte. Pohľadnica je vrstvená, vnútro a zadná strana bez textov v bielej farbe, posielam s ručne robenou obálkou."
          size-img="cca 10,5 x 10 cm"
          material-img="obyčajný papier, kartón"
          kind-img="decoupage, lepenie, cardmaking"
        />
        <postcard
          :source-pictutes="['/static/images/velkanoc/velkanoc39.jpg','/static/images/velkanoc/velkanoc40.jpg','/static/images/velkanoc/velkanoc41.jpg']"
          title-img="Venček z narcisov - 6 €"
          subtitle-img="Pohľadnica"
          details-img="...veľkonočná pohľadnica s motívom venčeka z narcisov, tie som vyrobila technikou decoupage, ručne vyrezala a nalepila v tvare venčeka v 3D efekte, pohľadničku som dozdobila mašličkou a pečiatkou - veselú veľkú noc-, posielam s ručne robenou obálkou na mieru."
          size-img="15 x 10,5 cm"
          material-img="obyčajný papier, kartón, špagát"
          kind-img="decoupage, lepenie, cardmaking"
        />
        <postcard
          :source-pictutes="['/static/images/darceky/darceky1.jpg','/static/images/darceky/darceky2.jpg','/static/images/darceky/darceky3.jpg','/static/images/darceky/darceky4.jpg']"
          title-img="V brezovom hájičku... - 6 €"
          subtitle-img="Zápisník"
          details-img="...malý zápisníček dekorovaný technikou decoupage z oboch vonkajších strán, prelakovaný (fotené pred lakovaním). Vnútro obsahuje 60 čistých listov, na voľno previazaný bielym špagátikom."
          size-img="...rozmery 15,5 x 11 cm"
          material-img="obyčajný papier, špagát, kartón"
          kind-img="decoupage, lepenie"
        />
      </b-card-group>
      <b-card-group deck>
        <postcard
          :source-pictutes="['/static/images/darceky/darceky5.jpg','/static/images/darceky/darceky6.jpg','/static/images/darceky/darceky7.jpg','/static/images/darceky/darceky8.jpg']"
          title-img="Červená lentilka - 7 €"
          subtitle-img="Krabička"
          details-img="...spomínam, keď sme dostali lentilky a červené sme troška namočili, pustili farbu a my sme si nimi rúžovali pery :) bodky na krabičke sú ako tie namočené lentilky postupne strácajúce farbu... ...malinká bodkovaná krabička nielen na lentilky, je zdobená technikou decoupage, prelakovaná ekolakom a previazaná, vnútro je bez zásahov, v surovom stave, spodok je dekorovaný. Krabička má vrchnák, bez kovania."
          size-img="...cca 12 x 8 x 6,5 cm"
          material-img="iné mäkké drevo"
          kind-img="decoupage"
        />
        <postcard
          :source-pictutes="['/static/images/darceky/darceky9.jpg','/static/images/darceky/darceky10.jpg','/static/images/darceky/darceky11.jpg','/static/images/darceky/darceky12.jpg']"
          title-img="Uži si každý okamih - 6 €"
          subtitle-img="Obrázok"
          details-img="...obrázok s motivačným nápisom - Tešiť sa z malých vecí :) Rámik je polotovar a samotný obrázok v okrúhlom tvare, je vyrobený technikou decoupage, ručne vyrezaný a nalepený na pevný biely fotokartón. Motív má iný odtieň bielej farby ako podklad, nesplýva s ním."
          size-img="...18 x 13 cm"
          material-img="kartón, obyčajný papier"
          kind-img="decoupage, lepenie"
        />
        <postcard
          :source-pictutes="['/static/images/darceky/darceky13.jpg','/static/images/darceky/darceky14.jpg','/static/images/darceky/darceky15.jpg']"
          title-img="Hviezdná obloha - 6 €"
          subtitle-img="Krabička"
          details-img="...krásne zasnená malinká krabička s nočnou oblohou plnou hviezd, bola vyrobená technikou decoupage, zdobený je len vrchnáčik, inak je bielej farby a vnútro je nezdobené. Krabička je previazaná bielym motúzikom. Zalakovaná nezávadným ekolakom. Môže byť dekoráciou detskej izbičky, vianočnou dekoráciou alebo na ukrytie malých tajomstiev ;) Farba krabičky je skôr tmavomodrá, na slnku s tyrkysovým nádychom, nepodarilo sa mi to hodnoverne zachytiť fotkou, ale je trocha svetlejšia ako na fotkách."
          size-img="vrchnáčik cca 10 x 10 cm, spodná časť cca 8,5 x 8,5 cm"
          material-img="iné mäkké drevo, špagát"
          kind-img="decoupage"
        />
      </b-card-group>
      <br>
      <b-card-group deck>
        <postcard
          :source-pictutes="['/static/images/darceky/darceky16.jpg','/static/images/darceky/darceky18.jpg','/static/images/darceky/darceky17.jpg','/static/images/darceky/darceky18.jpg']"
          title-img="Nekonečná láska - 11 €"
          subtitle-img="Zápisník"
          details-img="...zápisník alebo album pre najkrajšie chvíle v živote ženy :) ...zdobený motívom budúcej mamičky, ten bol vytvorený technikou decoupage, ručne vyrezaný a nalepený v 3D efekte. Predná a zadná strana sú z tvrdej lepenky a vrchné béžové papiere sú archivačnej hodnoty. Prizdobený výrezom z lepenky - Nekonečná láska - . Obsahuje 20 vnútorných listov, sú bielej farby, inak nezdobené."
          size-img="15,2 x 15,2 cm"
          material-img="archivačný papier, kartón, špagát, obyčajný papier"
          kind-img="decoupage, lepenie, cardmaking"
        />
        <postcard
          :source-pictutes="['/static/images/darceky/darceky19.jpg','/static/images/darceky/darceky20.jpg','/static/images/darceky/darceky21.jpg','/static/images/darceky/darceky22.jpg','/static/images/darceky/darceky23.jpg']"
          title-img="Keď cválajú... - 6 €"
          subtitle-img="Zápisník"
          details-img="...cítia sa slobodne. ...zápisník vyzdobený technikou decoupage. Veľmi príjemný na dotyk, akoby ste hladkali koníka :) Vnútro surové, bez zdobenia. Zápisník je polotovar, nie je ručne robený, vnútri 60 bielych listov."
          size-img="...cca 15,5 x 11 cm"
          material-img="obyčajný papier, kartón, špagát"
          kind-img="decoupage, lepenie"
        />
        <postcard
          :source-pictutes="['/static/images/darceky/darceky24.jpg','/static/images/darceky/darceky25.jpg','/static/images/darceky/darceky26.jpg']"
          title-img="Sloboda - 6 €"
          subtitle-img="Zápisník"
          details-img="...pre dobrodruha, ktorý má hlavu stále v oblakoch, na spomienky, plány, myšlienky :) ...zápisník vyzdobený technikou decoupage (len vrchná strana), prelakovaný lakom na decoupage. Na vnútornej  prednej strane je záložka na zakladanie lístkov, ústrižkov... .Zápisník je polotovar, nie je ručne robený, vnútri 60 bielych listov."
          size-img="...cca 15,5 x 11 cm"
          material-img="obyčajný papier, kartón"
          kind-img="decoupage, lepenie"
        />
      </b-card-group>
      <br>
      <b-card-group deck>
        <postcard
          :source-pictutes="['/static/images/valentin/valentin1.jpg','/static/images/valentin/valentin2.jpg']"
          title-img="Srdce domova - 6 €"
          details-img="...otváracia pohľadnica vytvorená motívom zo servítky a technikou decoupage. Motív srdca je ručne vyrezaný, väčšie srdiečko s kvetinkami je nalepené v 3D efekte, na menšom (vnútornom) srdiečku je v 3D efekte nalepený domček. Pohľadnica je vytvorená vrstvením papierov. Vnútro a zadná strana bez textu, v bielej farbe. Ku pohľadnici posielam ručne robenú obálku."
          size-img="...rozmery sú cca 15 x 15 cm"
          material-img="obyčajný papier, kartón"
          kind-img="decoupage, cardmaking, lepenie"
        />
        <postcard
          :source-pictutes="['/static/images/valentin/valentin3.jpg','/static/images/valentin/valentin4.jpg','/static/images/valentin/valentin5.jpg']"
          title-img="Magnetky láskyplné - 6 €"
          details-img="...magnetky, ktoré boli vytvorené technikou decoupage, prelakované lakom na decoupage, na bielej zadnej papierovej strane s okrúhlym magnetom. ...cena za sadu 6 ks magnetiek "
          size-img="cca 4,5 x 3,5 cm"
          material-img="obyčajný papier, kartón, magnet"
          kind-img="decoupage, lepenie"
        />
        <postcard
          :source-pictutes="['/static/images/valentin/valentin6.jpg','/static/images/valentin/valentin7.jpg','/static/images/valentin/valentin8.jpg','/static/images/valentin/valentin9.jpg','/static/images/valentin/valentin10.jpg']"
          title-img="Pohľadnica - 4,50 €"
          details-img="...otváracia pohľadnica s kvetinovým motívom, ten bol vytvorený technikou decoupage, ručne vyrezaný a nalepený v 3D efekte, dozdobené červenobielou šnúrkou a pečiatkou -z lásky-. Posielam s pevnou ručne robenou obálkou na mieru."
          size-img="15 x 10,5 cm"
          material-img="obyčajný papier, špagát"
          kind-img="decoupage, cardmaking, lepenie"
        />
      </b-card-group>
      <br>
      <b-card-group deck>
        <postcard
          :source-pictutes="['/static/images/magnetky/magnetka1.jpg','/static/images/magnetky/magnetka2.jpg']"
          title-img="Magnetka - 3,50 €"
          details-img="...okrúhla magnetka s motívom stromov v lese (impresia), použitá bola technika decoupage, podlepená fotokartónom vyššej gramáže, prelakovaná. Vzadu sú dva okrúhle magnety. Fotené pred lakovaním."
          size-img="cca 6 cm"
          material-img="kartón, magnet"
          kind-img="decoupage, lepenie"
        />
        <postcard
          :source-pictutes="['/static/images/magnetky/magnetka3.jpg','/static/images/magnetky/magnetka4.jpg']"
          title-img="Magnetka - 3,50 €"
          details-img="...okrúhla magnetka s motívom stromov a zasneženej cesty, použitá bola technika decoupage, podlepená fotokartónom vyššej gramáže, prelakovaná. Vzadu sú dva okrúhle magnety. Fotené pred lakovaním."
          size-img="cca 6 cm"
          material-img="kartón, magnet"
          kind-img="decoupage, lepenie"
        />
        <postcard
          :source-pictutes="['/static/images/visacky/visacka1.jpg','/static/images/visacky/visacka2.jpg']"
          title-img="Visačky - 2,50 €"
          details-img="...visačky vytvorené technikou decoupage, prelakované.V sade sú 3 kusy."
          size-img="7 x 5,5 cm"
          material-img="kartón, špagát"
          kind-img="decoupage, lepenie"
        />
      </b-card-group>
      <br>
      <b-card-group deck>
        <postcard
          :source-pictutes="['/static/images/kvietky/kvietky1.jpg','/static/images/kvietky/kvietky2.jpg']"
          title-img="Snežienky - 6 €"
          subtitle-img="Pohľadnica"
          details-img="...veľmi jemná, minimalistická pohľadnička so snežienkami, ktoré akoby práve vykúkali spod snehovej prikrývky :) Snežienky som vyrobila technikou decoupage, ručne vyrezala a nalepila na biely pohľadnicový základ v 3D efekte. Posielam s ručne robenou obálkou na mieru. Pohľadnička sa otvára zdola."
          size-img="15 x 10,5 cm"
          material-img="obyčajný papier, kartón"
          kind-img="decoupage, cardmaking, lepenie"
        />
        <postcard
          :source-pictutes="['/static/images/kvietky/kvietky3.jpg','/static/images/kvietky/kvietky4.jpg','/static/images/kvietky/kvietky5.jpg']"
          title-img="Rozkvitnutá halúzka - 4 €"
          subtitle-img="Pohľadnica"
          details-img="..otváracia pohľadnica s jemným kvetinovým motívom, ktorý bol vytvorený technikou decoupage, nalepený v 3D efekte na biely ručne robený pohľadnicový základ, pohľadnica je bez textov, na voľno previazaný maslovým motúzikom. Posielam s ručne robenou obálkou. Môžete ju poslať ako veľkonočný pozdrav, poslúži aj ako narodeninové prianie, či pozdrav k meninám :)"
          size-img="14,5 x 10,5 cm"
          material-img=""
          kind-img=""
        />
        <postcard
          :source-pictutes="['/static/images/kvietky/kvietky6.jpg','/static/images/kvietky/kvietky7.jpg']"
          title-img="Už kvitne - 4 €"
          subtitle-img="Pohľadnica"
          details-img="..otváracia pohľadnica s jemným kvetinovým motívom, ktorý bol vytvorený technikou decoupage, nalepený v 3D efekte na biely ručne robený pohľadnicový základ, pohľadnica je bez textov, na voľno previazaný tmavošedým motúzikom. Posielam s ručne robenou obálkou. Môžete ju poslať ako veľkonočný pozdrav, poslúži aj ako narodeninové prianie, či pozdrav k meninám :)"
          size-img="15 x 10,5 cm"
          material-img="obyčajný papier, kartón, špagát"
          kind-img="decoupage, lepenie, cardmaking"
        />
      </b-card-group>
      <b-card-group deck>
        <postcard
          :source-pictutes="['/static/images/kvietky/kvietky8.jpg','/static/images/kvietky/kvietky9.jpg','/static/images/kvietky/kvietky10.jpg']"
          title-img="Ruža - 6 €"
          subtitle-img="Pohľadnica"
          details-img="...otváracia pohľadnička s motívom ružičky v plnom kvete, tú som vytvorila technikou decoupage, ručne vyrezala a nalepila v 3D efekte a prizdobila bielou ľanovou šnúrkou. Posielam s pevnou ručne robenou obálkou. "
          size-img="15 x 10,5 cm"
          material-img="obyčajný papier, kartón, špagát"
          kind-img="decoupage, lepenie, cardmaking"
        />
        <postcard
          :source-pictutes="['/static/images/narodeniny/narodeniny1.jpg','/static/images/narodeniny/narodeniny2.jpg']"
          title-img="Horúca čokoláda - 5,50 €"
          subtitle-img="Pohľadnica"
          details-img="...zaručený recept na dobrú náladu horúca čokoláda so šľahačkou :) ...pošlite ju na pohľadnici, motív bol vytvorený technikou decoupage, ručne vyrezaný a nalepený v 3D efekte, dozdobené špagátikom a kvapkami čokolády (enamelové aplikácie) a textom -pre teba- (pečiatka). Pridanou hodnotu tejto pohľadničky je ručne robená obálka na  mieru."
          size-img="15 x 10,5 cm"
          material-img="obyčajný papier, špagát, kartón"
          kind-img="decoupage, cardmaking, lepenie"
        />
        <postcard
          :source-pictutes="['/static/images/narodeniny/narodeniny3.jpg']"
          title-img="Muffinková - 5 €"
          subtitle-img="Pohľadnica"
          details-img="...sladká muffinková pohľadnica vhodná k pre narodeninových alebo meninových oslávencov, bola vyrobená technikou decoupage, muffinky ručne vyrezané a nalepené v 3D efekte, dozdobené pečiatkou -Blahoželanie-. Pridanou hodnotou tejto pohľadničky je ručne robená obálka na mieru."
          size-img="15 x 10,5 cm"
          material-img="obyčajný papier, kartón"
          kind-img="decoupage, cardmaking, lepenie"
        />
      </b-card-group>
      <br>
      <b-card-group deck>
        <postcard
          :source-pictutes="['/static/images/narodeniny/narodeniny4.jpg','/static/images/narodeniny/narodeniny5.jpg','/static/images/narodeniny/narodeniny6.jpg']"
          title-img="Baletka - 4,60 €"
          subtitle-img="Pohľadnica"
          details-img="....pre princeznú k narodeninám :) ...otváracia pohľadnica s motívom baletky, ten bol vytvorený technikou decoupage, nalepený v 3d efekte. Pohľadnica je vrstvená, v bielej farbe, bez textov, dozdobená drobnými perličkami a previazaná ružovobielym motúzikom. Posielam s ručne robenou obálkou a visačkou :)"
          size-img="14,5 x 10,5"
          material-img="obyčajný papier, kartón, špagát"
          kind-img="decoupage, lepenie, cardmaking"
        />
        <postcard
          :source-pictutes="['/static/images/zvieratka/zvieratka1.jpg','/static/images/zvieratka/zvieratka2.jpg','/static/images/zvieratka/zvieratka3.jpg','/static/images/zvieratka/zvieratka4.jpg']"
          title-img="Mačky - 6,90 € / sada"
          subtitle-img="Pohľadnica"
          details-img="...sada pohľadníc s motívom mačiek, tie boli vytvorené technikou decoupage, ručne vyrezané a nalepené v 3D efekte, dozdobené žltobielou šnúrkou a pečiatkou. Posielam s ručne robenými obálkami na mieru. Uvedená cena je za sadu 2 pohľadníc + 2 handmade obálok."
          size-img="15 x 10,5 cm"
          material-img="obyčajný papier, špagát"
          kind-img="decoupage, cardmaking, lepenie"
        />
        <postcard
          :source-pictutes="['/static/images/povolania/povolania1.jpg','/static/images/povolania/povolania2.jpg','/static/images/povolania/povolania3.jpg']"
          title-img="Milovníčka kníh - 5,90 €"
          subtitle-img="Pohľadnica"
          details-img="...milá pohľadnica pre milovníčku kníh, bola vyrobené technikou decoupage, prizdobená látkovým buttonom a špagátikom, text je pečiatka, posielam spolu s pevnou ručne robenou obálkou."
          size-img="15 x 10,5 cm"
          material-img="obyčajný papier, špagát"
          kind-img="decoupage, cardmaking, lepenie"
        />
      </b-card-group>
      <br>
      <b-card-group deck>
        <postcard
          :source-pictutes="['/static/images/povolania/povolania4.jpg','/static/images/povolania/povolania5.jpg']"
          title-img="Jazdecká - 5 €"
          subtitle-img="Pohľadnica"
          details-img="...otváracia pohľadnica pre milovníka koní a jazdenia :) s motívom jazdeckých čižiem a prilby, tie boli vytvorené technikou decoupage, ručne vyrezané a nalepené v 3D efekte na krásny scrapbook papier v natur štýle s dreveným motívom. Pohľadnica je vrstvená, vnútro a zadná strana bez textov v perlovobielej farbe, na voľno previazaná natur špagátikom. Posielam s ručne robenou obálkou. Pohľadnička je vhodná pre dámy, pánov, ale aj menších jazdcov :)"
          size-img="14,5 x 10,5 cm"
          material-img="obyčajný papier, kartón, archivačný papier, špagát"
          kind-img="decoupage, cardmaking, lepenie"
        />
        <postcard
          :source-pictutes="['/static/images/deticky/deticky1.jpg','/static/images/deticky/deticky2.jpg']"
          title-img="Macík - 4,40 €"
          subtitle-img="Pohľadnica"
          details-img="....roztomilá pohľadnička k prvým narodeninám dievčatka, macko bol vyrobený technikou decoupage, ručne vyrezaný a nalepený v 3D efekte. Pohľadnička je dozdobená nálepkou. Pridanou hodnotou je ručne robená obálka na mieru."
          size-img="15 x 10,5 cm"
          material-img="obyčajný papier, kartón"
          kind-img="decoupage, cardmaking, lepenie"
        />
        <postcard
          :source-pictutes="['/static/images/deticky/deticky3.jpg','/static/images/deticky/deticky4.jpg','/static/images/deticky/deticky5.jpg','/static/images/deticky/deticky6.jpg']"
          title-img="Jelenček - 4 €"
          subtitle-img="Pohľadnica"
          details-img="...otváracia pohľadnička pre detičky s milým motívom srnčeka, ten bol vytvorený technikou decoupage, precízne ručne vyrezaný a nalepený na perlovobiely papierový výrez v 3D efekte. Pohľadnica je vrstvená, previazaná bielou šnúrkou, bez textu. Posielam s ručne robenou obálkou."
          size-img="...10 x 15 cm"
          material-img="obyčajný papier, kartón, špagát"
          kind-img="decoupage, cardmaking, lepenie"
        />
      </b-card-group>
      <br>
      <b-card-group deck>
        <postcard
          :source-pictutes="['/static/images/svadba/svadba1.jpg','/static/images/svadba/svadba2.jpg','/static/images/svadba/svadba3.jpg']"
          title-img="Ľudový motív - 7 €"
          subtitle-img="Pohľadnica"
          details-img="...elegantné svadobné blahoželanie s folkovým nádychom ...otváracia  pohľadnica s motívmi snúbencov, tie boli vytvorené technikou decoupage, ručne vyrezané,nalepené v 3D efekte. Prizdobené perličkovými nálepkami, krémovo-modrou papierovou páskou s ľudovým motívom. Pohľadnica je vrstvená, viaže sa bielou saténovou stužkou, zadná strana a vnútro bez textu v perlovo bielej farbe. Posielam s pevnou ručne robenou obálkou."
          size-img="...cca 15 x 14,5 cm (vrátane presahujúcich častí)"
          material-img="obyčajný papier, stužka"
          kind-img="decoupage, cardmaking, lepenie"
        />
        <postcard
          :source-pictutes="['/static/images/svadba/svadba3.jpg','/static/images/svadba/svadba5.jpg','/static/images/svadba/svadba6.jpg']"
          title-img="Snúbenci - 7 €"
          subtitle-img="Pohľadnica"
          details-img="...elegantné svadobné blahoželanie s florálnymi prvkami ...otváracia  pohľadnica s motívmi snúbencov, tie boli vytvorené technikou decoupage, ručne vyrezané,nalepené v 3D efekte. Prizdobené perličkovými nálepkami, malou bielou ružičkou a krásnym stredovým pásom scrapbook papiera s kvetinkovým vzorom. Pohľadnica je vrstvená, viaže sa perlovobielou saténovou stužkou, zadná strana a vnútro bez textu v bielej farbe. Posielam s pevnou ručne robenou obálkou"
          size-img="cca 15 x 15 cm"
          material-img="archivačný papier, obyčajný papier, kartón, stužka"
          kind-img="decoupage, cardmaking, lepenie"
        />
        <postcard
          :source-pictutes="['/static/images/svadba/svadba7.jpg','/static/images/svadba/svadba8.jpg']"
          title-img="Srdiečko - 4,50 €"
          subtitle-img="Pohľadnica"
          details-img="...pohľadnica s motívom srdiečka, to bolo vytvorené technikou decoupage, ručne vyrezané a nalepené v 3D efekte na biely pohľadnicový základ, dozdobené mašličkou fialovobielej farby. Posielam s ručne robenou obálkou na mieru."
          size-img="cca 15 x 10,5 cm"
          material-img="obyčajný papier, kartón, špagát"
          kind-img="decoupage, cardmaking, lepenie"
        />
      </b-card-group>
      <br>
      <b-card-group deck>
        <postcard
          :source-pictutes="['/static/images/babatka/babatka1.jpg','/static/images/babatka/babatka2.jpg','/static/images/babatka/babatka3.jpg']"
          title-img="Ružové topánočky - 15 €"
          subtitle-img="Album"
          details-img="...roztomilý album pre babätko, s motívom ružových topánočiek so šnúrkami zo stužky, topánočky sú vytvorené technikou decoupage, ručne vyrezané a nalepené v 3D efekte. Nápis -ten najkrajší darček- je nálepka. Album je polotovar slovenskej výroby. Obsahuje 20 listov v bielej farbe vyššej gramáže. Ozdobená je len vrchná časť, milým bonusom je záložka v podobe ružového cumlíka na bielej ľanovej šnúrke. Poslúži ako fotoalbum alebo zápisníček pre novopečených rodičov."
          size-img="15,2 x 15,2"
          material-img="kartón, špagát, stužka"
          kind-img="decoupage, lepenie"
        />
        <postcard
          :source-pictutes="['/static/images/babatka/babatka4.jpg','/static/images/babatka/babatka5.jpg','/static/images/babatka/babatka6.jpg']"
          title-img="Ružové papučky - 7 €"
          subtitle-img="Pohľadnica"
          details-img="...milá babätkovská pohľadnička s ružovými papučkami, tie boli vytvorené technikou decoupage, previazané stužkou a nalepené v 3D efekte. Pohľadnica je vrstvená, v bielej farbe bez textov. Posielam s ručne robenou obálkou na mieru."
          size-img="14,5 x 13"
          material-img="obyčajný papier, stužka, kartón"
          kind-img="decoupage, cardmaking, lepenie"
        />
        <postcard
          :source-pictutes="['/static/images/babatka/babatka7.jpg','/static/images/babatka/babatka8.jpg','/static/images/babatka/babatka9.jpg','/static/images/babatka/babatka10.jpg','/static/images/babatka/babatka11.jpg']"
          title-img="Modré topánočky - 17 €"
          subtitle-img="Album"
          details-img="...roztomilý album pre babätko, s motívom modrých topánočiek so šnúrkami zo stužky, topánočky sú vytvorené technikou decoupage, ručne vyrezané a nalepené v 3D efekte. Nápis -Náš chlapček- je nálepka. Album je polotovar slovenskej výroby. Obsahuje 20 listov v bielej farbe vyššej gramáže. Nálepkami sú ozdobené aj vnútorné strany (Vitaj doma, Konečne doma, Prvý úsmev, Prvá fotka...zopár foto prikladám), milým bonusom je záložka v podobe modrého cumlíka na bielej ľanovej šnúrke. Poslúži ako fotoalbum a zápisníček pre novopečených rodičov."
          size-img="15,2 x 15,2 cm"
          material-img="kartón, obyčajný papier, špagát"
          kind-img="decoupage, lepenie"
        />
      </b-card-group>
      <b-card-group deck>
        <postcard
          :source-pictutes="['/static/images/vianoce/vianoce1.jpg','/static/images/vianoce/vianoce2.jpg','/static/images/vianoce/vianoce3.jpg','/static/images/vianoce/vianoce4.jpg']"
          title-img="Linecké pečivo - 5 €"
          subtitle-img="Pohľadnica"
          details-img="...skladom len tento jedinečný kúsok ! ...sladké a voňavé linecké koláčiky plnené domácim ríbezľovým džemom u starkej na stole, ktorý práve utrela bielou ľanovou utierkou, len tak od práškového cukru, aby sme nemali biele rukávy :) ...vianočná pohľadnička plná spomienok, ozdobená je lineckým srdiečkom, ktoré som 'upiekla' technikou decoupage, nalepila na bielu čipku a ozdobila červenou šnúrkou. Ku pohľadničke posielam pevnú ručne robenú obálku na mieru."
          size-img="14,5 x 10,5 cm"
          material-img="obyčajný papier, kartón, špagát"
          kind-img="decoupage, lepenie, cardmaking"
        />
        <postcard
          :source-pictutes="['/static/images/vianoce/vianoce5.jpg','/static/images/vianoce/vianoce6.jpg','/static/images/vianoce/vianoce7.jpg']"
          title-img="Šťastný nový rok - 5,20 €"
          subtitle-img="Pohľadnica"
          details-img="...všetkým priaznivcom (trocha v predstihu) prajem spolu so sovičkou ako symbolom múdrosti, pohodový a veselý posledný deň roka a múdre rozhodnutia v prichádzajúcom roku 2020 :) ...otváracia novoročná pohľadnica s motívom sivej sovičky, ktorú som vytvorila technikou decoupage, ručne vyrezala a nalepila v 3D efekte na ručne vyrobený pohľadnicový základ v bielej farbe, pohľadničku som dozdobila trblietavými hviezdičkami a pečiatkou -šťastný nový rok-. Pridanou hodnotou tejto novoročnej pohľadničky je ručne robená obálka na mieru."
          size-img="15 x 10,5 cm"
          material-img="obyčajný papier, kartón"
          kind-img="decoupage, lepenie, cardmaking"
        />
        <postcard
          :source-pictutes="['/static/images/vianoce/vianoce8.jpg','/static/images/vianoce/vianoce9.jpg','/static/images/vianoce/vianoce10.jpg']"
          title-img="Srnka - 6,60 €"
          subtitle-img="Váza"
          details-img="...skladom len táto jediná ! ...krásna zimná váza poslúži ako efektná dekorácia počas zimných dní :) no môže poslúžiť aj ako dekorácia do detskej izbičky, na uschovanie drobných vecí (loptičky, pečiatky, pásky :) ) ...milá minimalistická váza s motívom srnky :)...táto vázička vznikla recykláciou ♻️ - odstránila som etiketky, dôkladne umyla a odmastila, precízne som naniesla bielu akrylovú farbu a srnku som aplikovala pomocou decoupage techniky. Celú vázičku som nakoniec pretrela nezávadným ekologickým lakom a potom som uviazala lesklú červenú šnúročku."
          size-img="výška 17,5 cm, priemer vrchného otvoru 7,5 cm"
          material-img="sklenený polotovar, špagát"
          kind-img="recyklácia, decoupage, lepenie"
        />
      </b-card-group>
      <br>
      <b-card-group deck>
        <postcard
          :source-pictutes="['/static/images/vianoce/vianoce11.jpg','/static/images/vianoce/vianoce12.jpg','/static/images/vianoce/vianoce13.jpg']"
          title-img="Hviezdička - 3,90 €"
          subtitle-img="Pohľadnica"
          details-img="...v tej vianočnej pohľadničke sa spája ľudový nádych s moderným výzorom :) kombinácia šitej ozdôbky s čipkou v minimalistickom vzhľade sa preto bude hodiť ako do chalúpky tak do moderného interiéru :) ...hviezdičku na pohľadničke som vyrobila technikou decoupage, ručne vyrezala a nalepila v 3D efekte, ozdobila som ju bielučkou čipkou a červenou mašličkou. Pridanou hodnotou tejto pohľadničky je nielen ručne robený základ, ale aj handmade obálka na mieru :)"
          size-img="15 x 10,5 cm"
          material-img="obyčajný papier, kartón, špagát"
          kind-img="decoupage, lepenie, cardmaking"
        />
        <postcard
          :source-pictutes="['/static/images/vianoce/vianoce14.jpg','/static/images/vianoce/vianoce15.jpg','/static/images/vianoce/vianoce16.jpg']"
          title-img="domčeky - 4 €"
          subtitle-img="Pohľadnica"
          details-img="...hviezdičky nad kostolíkom a dreveničkou :) ...vianočná pohľadnička s motívom domčekov a hviezdičiek v sebe prináša pokoj adventných dní a čaro Štedrého večera, motívy boli vytvorené technikou decoupage, ručne vyrezané a nalepené v 3D efekte. Pohľadnička je vrstvená, bez textov a posielam ju s pevnou ručne robenou obálkou na mieru."
          size-img="15 x 10,5 cm"
          material-img="obyčajný papier, kartón"
          kind-img="decoupage, lepenie, cardmaking"
        />
        <postcard
          :source-pictutes="['/static/images/vianoce/vianoce17.jpg','/static/images/vianoce/vianoce18.jpg','/static/images/vianoce/vianoce19.jpg']"
          title-img="Vanilkové rožky - 5 €"
          subtitle-img="Pohľadnica"
          details-img="...skladom len tento jedinečný kúsok ! ...sladké vanilkové rožky rozplývajúce sa na jazyku, to je tá pravá chuť vianočných sviatkov, tak ako minulý rok aj tento rok som ich napiekla aj na tejto pohľadničke :) ...rožteky sú vytvorené technikou decoupage, ručne vyrezané a nalepené na bielu čipku, dozdobené jemnou bielou šnúrkou. Ku pohľadničke posielam ručne robenú obálku na mieru."
          size-img="cca 14,5 x 10,5 cm"
          material-img="obyčajný papier, kartón, špagát"
          kind-img="decoupage, lepenie, cardmaking"
        />
      </b-card-group>
      <br>
      <b-card-group deck>
        <postcard
          :source-pictutes="['/static/images/vianoce/vianoce20.jpg','/static/images/vianoce/vianoce21.jpg','/static/images/vianoce/vianoce22.jpg']"
          title-img="Srnka - 4,50 €"
          subtitle-img="Pohľadnica"
          details-img="...radosť obdarovať druhého, to je čaro Vianoc :) ...roztomilá vianočná pohľadnica s motívom lesných zvieratiek, ten bol vytvorený technikou decoupage, ručne vyrezaný a nalepený v 3D efekte, pohľadnička je dozdobená trblietkavými vločkami a pečiatkou. Posielam s pevnou ručne robenou obálkou na mieru."
          size-img="15 x 10,5 cm"
          material-img="obyčajný papier, kartón"
          kind-img="decoupage, lepenie, cardmaking"
        />
        <postcard
          :source-pictutes="['/static/images/vianoce/vianoce23.jpg','/static/images/vianoce/vianoce24.jpg','/static/images/vianoce/vianoce25.jpg']"
          title-img="Srnky - 5,60 €"
          subtitle-img="Pohľadnica"
          details-img="...LEN JEDINÝ KÚSOK :) s týmto podkladovým papierom... ...čarovné chvíle v zasneženom lese so srnčou rodinkou :) ...túto roztomilú pohľadničku som vyzdobila motívom, ktorý som vyrobila technikou decoupage, ručne vyrezala a nalepila v 3D efekte na krásny scrapbook papier s bodkami :), pohľadničku som na voľno previazala bielou ľanovou šnúrkou a dozdobila pečiatkou. Pohľadnička á ručne robený základ perlovobielej farby, bez textov. Posielam s ručne robenou obálkou na mieru."
          size-img="15 x 10,5 cm"
          material-img="archivačný papier, špagát, obyčajný papier"
          kind-img="decoupage, lepenie, cardmaking"
        />
        <postcard
          :source-pictutes="['/static/images/vianoce/vianoce26.jpg','/static/images/vianoce/vianoce27.jpg','/static/images/vianoce/vianoce28.jpg']"
          title-img="❄Zvieratká v zime❄ - 4 €"
          subtitle-img="Pohľadnica"
          details-img="...otváracia vianočná pohľadnica s motívom lesných zvieratiek, ten bol vytvorený technikou decoupage. Pohľadnica je vrstvená, vnútro a zadná strana bez textov v krémovej farbe. Posielam s ručne robenou obálkou."
          size-img="...cca 15 x 10,5 cm"
          material-img="obyčajný papier, špagát"
          kind-img="decoupage, lepenie, cardmaking"
        />
      </b-card-group>
      <br>
      <b-card-group deck>
        <postcard
          :source-pictutes="['/static/images/vianoce/vianoce29.jpg','/static/images/vianoce/vianoce30.jpg','/static/images/vianoce/vianoce31.jpg']"
          title-img="❄Zima v lese❄ - 4 €"
          subtitle-img="Pohľadnica"
          details-img="...otváracia vianočná pohľadnica s motívom lesných zvieratiek, ten bol vytvorený technikou decoupage. Pohľadnica je vrstvená, vnútro a zadná strana bez textov v krémovej farbe. Posielam s ručne robenou obálkou."
          size-img="...cca 15 x 10,5 cm"
          material-img="obyčajný papier, špagát"
          kind-img="decoupage, lepenie, cardmaking"
        />
        <postcard
          :source-pictutes="['/static/images/vianoce/vianoce32.jpg','/static/images/vianoce/vianoce33.jpg','/static/images/vianoce/vianoce34.jpg','/static/images/vianoce/vianoce35.jpg']"
          title-img="Vlk - 6 €"
          subtitle-img="Pohľadnica"
          details-img="...SKLADOM LEN TENTO JEDINEČNÝ KÚSOK ! ...les ukrýva rôznych obyvateľov, najkrajším z nich je nepochybne vlk :) ...zimná pohľadnička s motívom vlka v zasneženom lese, použila som techniku decoupage a ručne rom vyrezala motív vlka, ktorý som nalepila v 3D efekte na krásny scrapbook papier s motívm ihličnatých stromov, pohľadničku som na voľno previazala šnúrkou. Pridanou hodnotou tejto pohľadničky je ručne robená obálka na mieru."
          size-img="15 x 10,5 cm"
          material-img="archivačný papier, obyčajný papier, kartón, špagát"
          kind-img="decoupage, lepenie, cardmaking"
        />
        <postcard
          :source-pictutes="['/static/images/vianoce/vianoce36.jpg']"
          title-img="Dve srnky- 4,50 €"
          subtitle-img="Pohľadnica"
          details-img="...milá jednoduchá pohľadnička s motívom srniek v zasneženom lese, motív som vytvorila technikou decoupage, ručne vyrezala a nalepila v 3D efekte na ručne vyrobený pohľadnicový základ bielej farby. Pohľadničku som na voľno previazala bielohnedým motúzikom. Ku pohľadnici posielam ručne robenú obálku. "
          size-img="15 x 10,5 cm"
          material-img="obyčajný papier, kartón, špagát"
          kind-img="decoupage, lepenie, cardmaking"
        />
      </b-card-group>
      <br>
      <b-card-group deck>
        <postcard
          :source-pictutes="['/static/images/vianoce/vianoce37.jpg']"
          title-img="Jeleň, laň - 4,80 €"
          subtitle-img="Pohľadnica"
          details-img="...zimná pohľadnička s motívom jelenej rodinky v zasneženom lese, ten som vytvorila technikou decoupage, ručne vyrezala a nalepila v 3D efekte na krásny scrapbook papier s motívom vločiek. Ku pohľadničke posielam ručne robenú obálku :)"
          size-img="14,5 x 10,5 cm"
          material-img="archivačný papier, obyčajný papier, kartón"
          kind-img="decoupage, lepenie, cardmaking"
        />
        <postcard
          :source-pictutes="['/static/images/vianoce/vianoce38.jpg','/static/images/vianoce/vianoce39.jpg','/static/images/vianoce/vianoce40.jpg','/static/images/vianoce/vianoce41.jpg','/static/images/vianoce/vianoce42.jpg']"
          title-img="Anjel - 5 €"
          subtitle-img="Pohľadnica"
          details-img="...LEN JEDINÝ KÚSOK ! ...s týmto anjelom pošlete čaro Vianoc svojim blízkym :) ...vianočná pohľadnica s motívom anjela s nostalgickým nádychom, vytvorila som ju technikou decoupage, ozdobila krásnym scrapbook papierom s bodkami a čipkou, ktorá jemne vykúka spod anjelika, text - čarovné chvíle - je pečiatkovaný. Posielam s ručne robenou obálkou na mieru."
          size-img="15 x 10,5 cm"
          material-img="archivačný papier, obyčajný papier, kartón"
          kind-img="decoupage, lepenie, cardmaking"
        />
        <postcard
          :source-pictutes="['/static/images/vianoce/vianoce43.jpg','/static/images/vianoce/vianoce44.jpg','/static/images/vianoce/vianoce45.jpg']"
          title-img="Vločka- 3,90 €"
          subtitle-img="Pohľadnica"
          details-img="...ak budú Vianoce bez snehu, poteší aspoň táto čipkovaná snehová vločka ❄ ...vianočná pohľadnička s motívom vločky sťaby čipkovanej, tú som vytvorila technikou decoupage, ručne vyrezala a nalepila v 3D efekte, dozdobila som ju bielou šnúrkou. Pridanou hodnotou tejto pohľadničky je ručne robená obálka na mieru."
          size-img="cca 15 x 10,5 cm"
          material-img="obyčajný papier, kartón, špagát"
          kind-img="decoupage, lepenie, cardmaking"
        />
      </b-card-group>
      <br>
      <b-card-group deck>
        <postcard
          :source-pictutes="['/static/images/vianoce/vianoce46.jpg','/static/images/vianoce/vianoce47.jpg','/static/images/vianoce/vianoce48.jpg']"
          title-img="Jeleň - 5,60 €"
          subtitle-img="Pohľadnica"
          details-img="❄...otváracia pohľadnica s motívom béžového jeleňa, ten bol vytvorený technikou decoupage, ručne vyrezaný a nalepený v 3D efekte na krásny scrapbook papier s motívom stromov v zimnom šate. Celá pohľadnička je na voľno previazaná dvojfarebným motúzikom. Vnútro a zadná strana bez textov v bielej farbe. Posielam s ručne robenou obálkou ❄ ! len jediný kus !"
          size-img="...cca 15 x 10,5 cm"
          material-img="obyčajný papier, archivačný papier, špagát"
          kind-img="decoupage, lepenie, cardmaking"
        />
        <postcard
          :source-pictutes="['/static/images/vianoce/vianoce49.jpg','/static/images/vianoce/vianoce50.jpg','/static/images/vianoce/vianoce51.jpg']"
          title-img="Jeleň pri stromčeku - 5,60 €"
          subtitle-img="Pohľadnica"
          details-img="...vianočná pohľadnica s motívom jeleňa, ten bol vyrobený technikou decoupage, precízne ručne vyrezaný a nalepený v 3D efekte na scrapbook papier s trblietavým ihličnatým stromčekom. Pohľadnica je dozdobená papierovými vločkami a previazaná ľanovou šnúrkou. Posielam s ručne robenou obálkou. ! len jediný kus !"
          size-img="15 x 10,5 cm"
          material-img="archivačný papier, obyčajný papier, kartón, špagát"
          kind-img="decoupage, lepenie, cardmaking"
        />
        <postcard
          :source-pictutes="['/static/images/vianoce/vianoce52.jpg','/static/images/vianoce/vianoce53.jpg','/static/images/vianoce/vianoce54.jpg','/static/images/vianoce/vianoce55.jpg']"
          title-img="Vločky- 4 €"
          subtitle-img="Pohľadnica"
          details-img="...romantická vianočná pohľadnica s motívom čipkovaných vločiek, tie boli vytvorené technikou decoupage, ručne vyrezané a nalepené v 3D efekte. Pohľadnička je na voľno previazaná bielou ľanovou a béžovou bavlnenou šnúrkou. Pohľadnica je bielej farby bez textov. Posielam s ručne robenou obálkou na mieru."
          size-img="14,5 x 10,5 cm"
          material-img="obyčajný papier, kartón, špagát"
          kind-img="decoupage, lepenie, cardmaking"
        />
      </b-card-group>
      <br>
      <b-card-group deck>
        <postcard
          :source-pictutes="['/static/images/vianoce/vianoce56.jpg','/static/images/vianoce/vianoce57.jpg','/static/images/vianoce/vianoce58.jpg']"
          title-img="Šišky - 5 €"
          subtitle-img="Pohľadnica"
          details-img="...všetko sa ligoce, už prišli Vianoce :) ...všetkým priaznivcom prajem krásne prežitie vianočných sviatkov :) ...vianočná pohľadnica so šiškovým venčekom, ten bol vytvorený technikou decoupage, šišky ručne vyrezané a naaranžované do venčeka, ten som dozdobila bieločervenou šnúrkou, maličkou vetvičkou cezmíny a trblietavými hviezdičkami. Pohľadnička je bez textov okrem pečiatky - všetko sa ligoce-. Posielam s ručne robenou obálkou."
          size-img="15 x 10,5 cm"
          material-img="obyčajný papier, kartón, špagát"
          kind-img="decoupage, lepenie, cardmaking"
        />
        <postcard
          :source-pictutes="['/static/images/vianoce/vianoce59.jpg','/static/images/vianoce/vianoce60.jpg','/static/images/vianoce/vianoce61.jpg']"
          title-img="Vianočná ruža - 5 €"
          subtitle-img="Pohľadnica"
          details-img="...elegantná pohľadnička s motívom vianočnej ruže, tá bola vytvorená technikou decoupage, ručne vyrezaná a nalepená v 3D efekte, dozdobené červenobielou šnúrkou. Pridanou hodnotou tejto pohľadničky je ručne robená obálka na mieru."
          size-img="cca 15 x 10,5 cm"
          material-img="kartón, špagát, obyčajný papier"
          kind-img="decoupage, lepenie, cardmaking"
        />
        <postcard
          :source-pictutes="['/static/images/vianoce/vianoce62.jpg','/static/images/vianoce/vianoce63.jpg','/static/images/vianoce/vianoce64.jpg']"
          title-img="Jazvečík- 5,60 €"
          subtitle-img="Pohľadnica"
          details-img="...milá vianočná pohľadnička s motívom jazvečíka v mikulášskej čiapočke, ktorý čaká na svoj darček :) alebo je ním on?  ...len jediný kus! Psíček bol vytvorený technikou decoupage, ručne fúzik po fúziku vyrezaný a nalepený v 3D efekte na krásny scrapbook papier s motvím vetvičiek, dozdobené červenobielou šnúrkou. Pridanou hodnotou tejto pohľadničky je ručne robená obálka na mieru."
          size-img="15 x 10,5 cm"
          material-img="archivačný papier, obyčajný papier, kartón, špagát"
          kind-img="decoupage, lepenie, cardmaking"
        />
      </b-card-group>
      <br>
      <b-card-group deck>
        <postcard
          :source-pictutes="['/static/images/vianoce/vianoce65.jpg','/static/images/vianoce/vianoce66.jpg','/static/images/vianoce/vianoce67.jpg','/static/images/vianoce/vianoce68.jpg']"
          title-img="Červené vločky - 5 €"
          subtitle-img="Pohľadnica, Visačky"
          details-img="...vianočná pohľadnica s motívom červených vločiek, tie boli vytvorené technikou decoupage, ručne vyrezané a nalepené v 3D, dozdobené pečiatkou. Základ pohľadnice je tiež ručne robený v bielej farbe bez textov. Posielam s ručne robenou obálkou. Posielam so sadou visačiek s podobným motívom :)"
          size-img="14,5 x 10,5 cm"
          material-img="obyčajný papier, kartón"
          kind-img="decoupage, lepenie, cardmaking"
        />
        <postcard
          :source-pictutes="['/static/images/vianoce/vianoce69.jpg','/static/images/vianoce/vianoce70.jpg','/static/images/vianoce/vianoce71.jpg','/static/images/vianoce/vianoce72.jpg','/static/images/vianoce/vianoce73.jpg','/static/images/vianoce/vianoce74.jpg']"
          title-img="Vianočná ruža veselé vianoce - 5 €"
          subtitle-img="Pohľadnica, Visačky"
          details-img="...vianočná pohľadnica s vianočnou ružou, tá bola vytvorená technikou decoupage, ručne vyrezaná a nalepená v 3D efekte, nápis Veselé Vianoce je nálepka. Pohľadnica je vrstvená, bez textov a v bielej farbe. Posielam s ručne robenou obálkou a sadou visačiek 4 ks."
          size-img="... 15 x 10,5 cm"
          material-img="obyčajný papier, kartón"
          kind-img="decoupage, lepenie, cardmaking"
        />
        <postcard
          :source-pictutes="['/static/images/vianoce/vianoce75.jpg','/static/images/vianoce/vianoce76.jpg','/static/images/vianoce/vianoce77.jpg','/static/images/vianoce/vianoce78.jpg']"
          title-img="Vtáčik- 4 €"
          subtitle-img="Pohľadnica"
          details-img="...zimná pohľadnica s milým motívom vtáčika v štrikovanej čiapočke, ktorý bol vytvorený technikou decoupage, nalepený v 3D efekte. Pohľadnica je na voľno previazaná červenobielym motúzikom a dozdobená nálepkou - v teple -. Posielam s pevnou ručne robenou obálkou."
          size-img="14,5 x 10,5 cm"
          material-img="obyčajný papier, kartón, špagát"
          kind-img="decoupage, lepenie, cardmaking"
        />
      </b-card-group>
    </b-card>
  </b-col>
</template>

<script>
import { ref } from "@vue/composition-api"
import Picture from "./Picture"

export default {
  name: 'All',
  components: {
    'postcard': Picture
  },
  setup(context) {
    const bla = ref('...All')
    return {
      bla
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/All.vue